import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

import { ContactsButton } from './ContactsButton';
import { DeviceQueries } from './index';

export const ContactFormForm = styled(Form)`
  font-size: 14px;

  input, select, input:disabled, select:disabled {
    font-size: 14px;
  }

  input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
`;

export const ViewContactField = styled.div`
  margin-left: 6px;
  font-size: 14px;
  flex: 0 0 auto;
  width: 100%;
`;

export const ViewContactCaption = styled.span`
  font-weight: 100;
  color: #1a1a1a;
  padding-left: 8px;
`;

export const ViewContactThirdPartyIcon = styled.img`
  max-width: 15px;
  max-height: 15px;
  margin-right: 6px;
  margin-top: -1px;
`;

export const ThirdPartyIdText = styled.a`
  && {
    color: #009bdf;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2px;
  }
`;

export const DropDownClickable = styled(Form.Select)`
  font-size: 14px;
  cursor: pointer;
  border: solid 1px #009bdf;
  padding: 0.5rem 2.25rem 0.5rem 1.5rem;

  @media (${DeviceQueries.mobile}) {
    padding: 0.5rem 1.25rem 0.5rem 10px;
  }
`;

export const SubmitButtonGroup = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: right;

  ${ContactsButton} {
    margin-right: 0;
  }
`;

export const FieldCol = styled(Col)`
  margin-bottom: 10px;
`

export const DeleteIcon = styled.img`
  cursor: pointer;
  width: 35px;
  margin-left: -10px;
  margin-top: 5px;
`;
